import { useNavigate } from "react-router-dom";
import { ROUTES } from "../shared/utils";

export const useNavigation = () => {

    const navigate = useNavigate();

    const goToPortfolioProjects = (portfolioName: string, portfolioId: number) => {
        navigate(ROUTES.PORTFOLIO_PROJECTS.replace(':portfolioName', portfolioName.replace(' ', '-')).replace(':portfolioId', String(portfolioId)));
    };

    const goToPortfolioDetails = (portfolioName: string, portfolioId: number) => {
        navigate(ROUTES.PORTFOLIO_PROGRAMME_DASHBOARD.replace(':portfolioName', portfolioName.replace(' ', '-')).replace(':portfolioId', String(portfolioId).replace(' ', '-')));
    };

    const goToProjectDetails = (projectId: number, projectName: string) => {
        navigate(ROUTES.PROJECTS_DETAILS.replace(':projectId', String(projectId)).replace(':projectName', projectName.replace(' ', '-')).replace(':projectSection', String('dashboard')));
    };

    const goToProjectDetailsFromPortfolio = (portfolioName: string, portfolioId: string, projectId: string, projectName: string) => {
        navigate(ROUTES.PORTFOLIO_PROJECT_DETAILS.replace(':portfolioName', portfolioName.replace(' ', '-')).replace(':portfolioId', String(portfolioId)).replace(':projectId', String(projectId)).replace(':projectName', projectName.replace(' ', '-')).replace(':projectSection', 'dashboard'));
    };

    const goToJeopardyDetails = (jeopardyId: number) => {
        navigate(ROUTES.JEOPARDY_MANAGER_DETAILS.replace(':jeopardyId', String(jeopardyId)));
    };

    const goToAddProject = () => {
        navigate(ROUTES.ADD_PROJECT);
    };

    const goToEditProject = (projectId: string) => {
        navigate(ROUTES.EDIT_PROJECT.replace(':projectId', projectId));
    };

    const goToRecurringTasks = ({ projectId, projectName }: { projectId: number, projectName: string }) => {
        // navigate(`/project/${projectId}/recurring-tasks`);
        navigate(ROUTES.PROJECTS_DETAILS_RECURRING_TASKS.replace(':projectId', String(projectId)).replace(':projectName', projectName.replace(' ', '-')));
    };

    const goToSchedulePlanning = ({ projectId, projectName, objectId, type }: { projectId: number, projectName: string, objectId: number, type: string }) => {
        navigate(ROUTES.PROJECTS_DETAILS_SCHEDULE_AND_PLANNING.replace(':projectId', String(projectId)).replace(':projectName', projectName.replace(' ', '-')).concat(`?id=${objectId}&type=${type}`));
    };

    const goToStageGates = ({ projectId, projectName, objectId }: { projectId: number, projectName: string, objectId: number }) => {
        navigate(ROUTES.PROJECTS_DETAILS_STAGE_GATES.replace(':projectId', String(projectId)).replace(':projectName', projectName.replace(' ', '-')).concat(`?selected=true&id=${objectId}`));
    };

    const goToRiskDashboard = ({ id }: { id?: string }) => {
        if (id) {
            navigate(ROUTES.RISK_DASHBOARD.concat(`?tab=risk-register&selected=true&id=${id}`));
        } else {
            navigate(ROUTES.RISK_DASHBOARD);
        }
    };

    const goToQueries = (projectId: number) => {
        navigate(`/queries?selected=true&id=${projectId}`);
    };

    const goToMeetingDetails = (meetingId: number) => {
        navigate(`/meeting-manager?tab=meetingDetails&meeting_id=${meetingId}`);
    };

    const goToAddPortfolio = () => {
        navigate(ROUTES.ADD_PORTFOLIO);
    };

    const goToEditPortfolio = (portfolioId: number) => {
        navigate(ROUTES.EDIT_PORTFOLIO.replace(':portfolioId', String(portfolioId)));
    };

    return {
        goToPortfolioProjects,
        goToProjectDetails,
        goToJeopardyDetails,
        goToPortfolioDetails,
        goToAddProject,
        goToEditProject,
        goToRecurringTasks,
        goToSchedulePlanning,
        goToStageGates,
        goToRiskDashboard,
        goToQueries,
        goToMeetingDetails,
        goToAddPortfolio,
        goToEditPortfolio,
        goToProjectDetailsFromPortfolio
    };

};